import { create } from 'zustand';

type LoadingState = {
  isLoading: boolean;
  pendingRequests: number;
  startLoading: () => void;
  stopLoading: () => void;
};

export const useLoadingState = create<LoadingState>((set) => ({
  isLoading: false,
  pendingRequests: 0,
  startLoading: () =>
    set((state) => ({
      pendingRequests: state.pendingRequests + 1,
      isLoading: true,
    })),
  stopLoading: () =>
    set((state) => ({
      pendingRequests: Math.max(0, state.pendingRequests - 1),
      isLoading: state.pendingRequests > 1,
    })),
})); 